export function markdown(string: string): string {
    const regex: RegExp = /(.*)(\*(.+)\*)(.*)/gi
    return string.replace(regex, "$1<b>$3</b>$4")
  }